import { ITypedReduxAction } from '../../types/redux/actionType';
import { TRoute } from '../../types/route';

export enum ERouteActionTypes {
  SetRoute = 'chats/route/setRoute',
  ChangeRoute = 'chats/route/changeRoute',
}

export interface IChangeRouteAction {
  route: TRoute;
  notClearCurrentOpenedChatId?: boolean;
}

export interface ISetRouteAction {
  route: TRoute;
  cleanRemovedFromSpamChatId?: boolean;
  cleanRemovedFromArchiveChatId?: boolean;
}

export type TRouteActions =
  | ITypedReduxAction<ERouteActionTypes.SetRoute, ISetRouteAction>
  | ITypedReduxAction<ERouteActionTypes.ChangeRoute, IChangeRouteAction>;
